import { fabric } from 'fabric';
import { stampParamsFromLinkData } from './stampAreaConfig';

function uiBrightnessToFabric(value) {
  return (Number(value) - 100) / 100;
}

function buildStampImageFilters(params) {
  const filters = [];
  if (!fabric.Image?.filters) return filters;

  const brightness = Number(params.brightness);
  if (brightness !== 100 && fabric.Image.filters.Brightness) {
    filters.push(new fabric.Image.filters.Brightness({
      brightness: uiBrightnessToFabric(brightness),
    }));
  }

  if (params.wrinkleFit && fabric.Image.filters.Contrast) {
    const intensity = Math.max(0, Math.min(100, Number(params.wrinkleIntensity) || 0)) / 100;
    filters.push(new fabric.Image.filters.Contrast({
      contrast: -0.08 - intensity * 0.28,
    }));
  }

  return filters;
}

function buildStampDropShadow(params, bounds) {
  if (!params.shadow) return null;

  const refSize = Math.max(bounds?.width || 0, bounds?.height || 0, 1);
  const scale = refSize / 200;
  const blur = Math.max(0, (Number(params.shadowDiffusion) / 100) * 36 * scale);

  return new fabric.Shadow({
    color: params.shadowColor || '#666666',
    blur,
    offsetX: (Number(params.shadowOffsetX) || 0) * scale,
    offsetY: (Number(params.shadowOffsetY) || 0) * scale,
  });
}

/** 将印花效果参数应用到画布上的参考印花预览图 */
export function applyStampPreviewEffects(img, linkData, options = {}) {
  if (!img) return;

  const params = stampParamsFromLinkData(linkData);
  const opacity = Math.max(0, Math.min(1, (Number(params.opacity) || 100) / 100));

  img.set({
    opacity,
    globalCompositeOperation: params.wrinkleFit ? 'multiply' : 'source-over',
    shadow: buildStampDropShadow(params, options.bounds),
  });

  const filters = buildStampImageFilters(params);
  img.filters = filters;
  if (typeof img.applyFilters === 'function') {
    img.applyFilters();
  }
}

export const STAMP_PREVIEW_EFFECT_KEYS = [
  'opacity',
  'brightness',
  'fillMode',
  'objectPosition',
  'stampRotation',
  'wrinkleFit',
  'wrinkleIntensity',
  'shadow',
  'shadowDiffusion',
  'shadowOffsetX',
  'shadowOffsetY',
  'shadowColor',
];
